<template>
  <section class="lab-card">
    <header v-if="title || $slots.actions" class="lab-card-h">
      <h3 v-if="title">{{ title }}</h3><span v-if="description" class="lab-desc">{{ description }}</span>
      <div v-if="$slots.actions" class="lab-button-row"><slot name="actions" /></div>
    </header>
    <div class="lab-card-b" :class="{ tight }"><slot /></div>
  </section>
</template>
<script>
export default { name: 'NetworkLabPanel', props: { title: String, description: String, tight: Boolean } }
</script>
